module.exports = __webpack_public_path__ + "images/2db16868a4b1c4d56c73c1fbf7681202-profile_overlay.jpg";